import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PageChanger from "../../Helpers/Components/Pagination"
import Handler from "../../Helpers/Components/Handler"
import moment from "moment";
import TablePlaceHolder from "../../Helpers/Components/TablePlaceHolder"
import DatePicker from "react-multi-date-picker";
import { DropdownToggle, DropdownButton } from '../../Helpers/Components/Dropdown';
import { toast } from "react-toastify";
import Modal from "../../Helpers/Components/Modal";
import { Popover } from 'bootstrap';

const List = () => {
    const { pageNo } = useParams()
    const navigate = useNavigate()
    const [info, setInfo] = useState(false)
    const [next, setNext] = useState(false)
    const [loading, setLoading] = useState(false)
    const [custDetails, setCustDetails] = useState([])
    const [custStatus, setCustStatus] = useState("All")
    const [link, setLink] = useState(false)
    const [details, setDetails] = useState({ name: "", phone: "" })
    const validName = new RegExp('^[A-Za-z\\s]*$');
    const setPageNo = (value) => {
        navigate(`/msd/${value}`)
    }
    const getCustomerDetails = async () => {
        setLoading(true)
        const response = await Handler({
            method: "post", url: `/admin/customer/details/${pageNo - 1}`,
            data: { ...(custStatus !== "All" ? { custStatus } : {}) }
        })
        if (response?.success) {
            setCustDetails(response?.data?.current)
            setNext(response?.data?.next)
        } else {
            setCustDetails([])
            setNext(false)
        }
        setLoading(false)
    }
    const register = async () => {
        if (!details?.name || !validName?.test(details?.name)) {
            toast.error("Invalid Name")
        } else if (!details?.phone) {
            toast.error("Invalid Phone")
        } else {
            setLoading(true)
            const response = await Handler({ method: 'post', data: details, url: "/admin/create/customer" })
            if (response?.success) {
                getCustomerDetails()
                toast.success(response?.message)
                setInfo(false)
            } else {
                toast.error(response?.message)
                setLoading(false)
            }
        }
    }
    useEffect(() => {
        getCustomerDetails()
    }, [pageNo, custStatus])
    useEffect(() => {
        if (!info) {
            setDetails({ name: "", phone: "" })
        }
    }, [info])
    useEffect(() => {
        const popoverTrigger = document.getElementById('basic-addon2');
        if (popoverTrigger) {
          new Popover(popoverTrigger);
        }
      }, []);
    return (
        <React.Fragment>
            <h5 className="text-center text-theme fs-4">MSD Customer List</h5>
            <div className="layout-card mt-4">
                <div className="row justify-content-between align-items-center">
                    <div className="col-lg-4">
                        {/* <div className="input-group mb-3">
                            <input type="text" className="form-control search-input" autoComplete="off" placeholder="Search..." value={filter?.search} onChange={handleChange} name="search" />
                            <span className="input-group-text cancel-icon">{filter?.search ? <i className="fa-solid fa-circle-xmark cursor-pointer text-theme" onClick={() => { setFilter((prev) => ({ ...prev, search: "" })); setPageNo(1) }}></i> : ""}</span>
                        </div> */}
                    </div>
                    <div className="col-lg-4 text-end">
                        <button className="btn-theme btn" onClick={() => { setInfo(true) }}>Register</button>
                    </div>
                </div>
                <div className='overflow list-table mt-3'>
                    <table className="table-bg table" borderless="true">
                        <thead>
                            <tr className="border-bottom" >
                                <th>S. No</th>
                                <th>Created At</th>
                                <th> Customer Name </th>
                                <th> Created By </th>
                                <th> Primary Number </th>
                                <th> Email </th>
                                <th> Type </th>
                                <th> <DropdownToggle label={
                                      <> Status <i className="fa-solid fa-caret-down"></i> </>}>
                                    <DropdownButton label="All" className={`${custStatus === "All" ? "active-option" : ""}`} onClick={() => { setCustStatus("All"); setPageNo(1) }} />
                                    <DropdownButton label="Accepted" className={`${custStatus === "Accepted" ? "active-option" : ""}`} onClick={() => { setCustStatus("Accepted"); setPageNo(1) }} />
                                    <DropdownButton label="Waiting" className={`${custStatus === "Waiting" ? "active-option" : ""}`} onClick={() => { setCustStatus("Waiting"); setPageNo(1) }} />
                                    <DropdownButton label="Rejected" className={`${custStatus === "Rejected" ? "active-option" : ""}`} onClick={() => { setCustStatus("Rejected"); setPageNo(1) }} />
                                </DropdownToggle> </th>
                            </tr>
                        </thead>
                        <tbody>
                            {!loading ?
                                (custDetails && custDetails?.length !== 0 ? custDetails?.map((value, i) => {
                                    return (
                                        <tr key={i} className={`table-content-row ${!value?.cust_status === "Rejected" ? "text-red" : ""}`}>
                                            <td>{(pageNo - 1) > 0 ? (i + 1 === 10) ? (pageNo - 1) + 1 + "0" : String(pageNo - 1) + (i + 1) : (i + 1)}</td>
                                            <td>{value?.register_date ? moment(new Date(value?.register_date))?.format("DD/MM/YYYY") : "-"}</td>
                                            <td><a className="" href={`/msd/view/${value?.cust_id}`}>{value?.cust_name || "-"}</a></td>
                                            <td>{value?.created_by || "-"}</td>
                                            <td>{value?.mobile_1 || "-"}</td>
                                            <td>{value?.email || "-"}</td>
                                            <td>{value?.cust_type || "-"}</td>
                                            <td>{value?.cust_status || "-"}</td>
                                        </tr>
                                    )
                                }) :
                                    <tr className='text-center' ><td colSpan={8}>No Data Found</td></tr>)
                                : <TablePlaceHolder count={8} />
                            }
                        </tbody>
                    </table>
                </div>
                <PageChanger previousValue={Number(pageNo) > 1} nextValue={next} current={Number(pageNo)} onPageChange={setPageNo} pageValue='msd' />
            </div>
            <Modal header="Create Customer" onShow={info} toggle={() => setInfo(false)} overlayToggle={() => setInfo(false)}>
                <div className="mb-3">
                    <label htmlFor="name" className="form-label"> Name </label>
                    <input autoComplete="off" disabled={loading} placeholder="Name" onChange={(e) => { setDetails((prev) => ({ ...prev, name: e.target.value })) }} id="name" type="text" name="name" value={details?.name || ""} className="form-control input-theme text-uppercase" />
                </div>
                <div className="mb-3">
                    <label htmlFor="name" className="form-label"> Phone Number </label>
                    <input autoComplete="off" disabled={loading} placeholder="Phone Number" maxLength={10} onChange={(e) => { if (e.target.value == Number(e.target.value)) { setDetails((prev) => ({ ...prev, phone: e.target.value })) } }} id="name" type="text" name="name" value={details?.phone || ""} className="form-control input-theme text-uppercase" />
                </div>
                <div className="pt-4 pb-2 text-center">
                    <button className="btn btn-sm btn-success" disabled={loading} onClick={register}>{loading ? <i className="fa-solid fa-spinner fa-spin"></i> : "Submit"}</button><button className="btn btn-sm btn-danger" disabled={loading} onClick={() => setInfo(false)}>{loading ? <i className="fa-solid fa-spinner fa-spin"></i> : "Cancel"}</button>
                </div>
            </Modal>
            <Modal header="Copy Link" onShow={link} toggle={() => setLink(false)} overlayToggle={() => setLink(false)}>
                <div className="input-group mb-3">
                    <input type="text" autoComplete="off" className="form-control" disabled readOnly aria-describedby="basic-addon2" value="https://customer.madrasselfdrivecars.com/" />
                    <button data-bs-toggle="popover" data-bs-content="Copied" data-bs-placement="top" className="btn input-group-text cursor-pointer" id="basic-addon2" onClick={() => { navigator.clipboard.writeText("https://customer.madrasselfdrivecars.com/"); }}><i className="fa-solid fa-copy"></i></button>
                </div>
                <div className="pt-4 pb-2 text-center">
                    <button className="btn btn-sm btn-danger" onClick={() => setLink(false)}>Close</button>
                </div>
            </Modal>
        </React.Fragment>
    )
}

export default List;